/**
 * Copyright 2020 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import styles from './BlogProductTypeGrid.module.scss';
import { CMSHeadline } from '@/features/contentstack/components/CMSHeadline/CMSHeadline';
import { BlogProductCard } from './BlogProductCard';
import { View } from '@az/starc-ui';
import cx from 'classnames';
import type { ContentStackPost } from '@/features/contentstack/interface';

type Props = {
  content: ContentStackPost['product_grid'];
  gridIndex: number;
};

export const BlogProductTypeGrid = ({ content, gridIndex }: Props) => {
  return (
    <section>
      {content?.headline ? (
        <CMSHeadline
          className={cx({
            [styles.helveticaFont]: content.header_text_style === 'Helvetica Blog Header',
            [styles.azCondensedFont]:
              content.header_text_style === 'AutoZone Condensed Blog Header',
          })}
          underline={content.headline_underlined}
        >
          {content.headline}
        </CMSHeadline>
      ) : null}
      <View
        className={cx(styles.grid, {
          [styles.fourWrap]: content?.layout === 'Four',
          [styles.threeWrap]: content?.layout === 'Three',
          [styles.twoWrap]: content?.layout === 'Two',
        })}
        justify="start"
        align="stretch"
        direction="row"
        maxWidth={{ s: '719px', m: '1139px', l: '1560px' }}
        data-testid={`product-grid-${gridIndex}`}
      >
        {content?.product_card?.map((singleProduct, index) => (
          <View.Item
            key={`${singleProduct.product_name}-${index}`}
            className={cx(styles.layoutTwo, {
              [styles.layoutThree]: content.layout === 'Three',
              [styles.layoutFour]: content.layout === 'Four',
              [styles.smallMediaRowLayout]: content.mobile_two_card_split === true,
            })}
          >
            <BlogProductCard
              product={singleProduct}
              detailsAlignment={content.product_details_alignment}
              headerTextStyle={singleProduct.product_name_text_style}
              mobileTwoCardSplit={content.mobile_two_card_split}
            />
          </View.Item>
        ))}
      </View>
    </section>
  );
};
